/**
 * FAQ Block - Frontend View Script
 * Simple vanilla JavaScript for FAQ toggle functionality
 */
function init() {
  // Find all FAQ blocks
  const faqBlocks = document.querySelectorAll('[data-block="papa-lp-faq"]');

  faqBlocks.forEach((block) => {
    // Skip if already initialized
    if (block.dataset.initialized === '1') return;

    // Find all FAQ items within this block
    const faqItems = block.querySelectorAll('.faq-item');

    faqItems.forEach((item) => {
      const header = item.querySelector('.faq-item__header');
      const panel = item.querySelector('.faq-item__panel');
      const iconSvg = item.querySelector('.faq-item__icon-svg');

      if (!header || !panel || !iconSvg) return;

      // Add click listener to toggle open/closed state
      header.addEventListener('click', () => {
        const isOpen = panel.classList.contains('faq-item__panel--open');

        if (isOpen) {
          // Close
          item.classList.remove('faq-item--open');
          panel.classList.remove('faq-item__panel--open');
          iconSvg.classList.remove('faq-item__icon-svg--open');
          header.setAttribute('aria-expanded', 'false');
        } else {
          // Open
          item.classList.add('faq-item--open');
          panel.classList.add('faq-item__panel--open');
          iconSvg.classList.add('faq-item__icon-svg--open');
          header.setAttribute('aria-expanded', 'true');
        }
      });
    });

    // Mark as initialized
    block.dataset.initialized = '1';
  });
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

// Export for manual re-initialization
window.PapaLpFaqInit = init;

